import React from "react";

const CustomButton = (props) => {
  return (
      <button
        className={`rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 ${props.styleType} ${props.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        onClick={props.handleClick}
        type={props.type}
        disabled={props.disabled}
      >
        {props.title}
      </button>
  );
};

export default CustomButton;
